import Vue from 'vue';
import Vuex from 'vuex';
import userStore from './user';

Vue.use(Vuex);
export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    seccion: 'INICIO',
    certificadosdeempresa: [
      {
        codigo: 'RDR',
        sello: 'selloRDR',
        certificado: 'certificado-0001.pfx',
        nombre: 'Redor S.L.'
      },
      {
        codigo: 'MDS',
        sello: 'selloMDS',
        certificado: 'certificado-0001.pfx',
        nombre: 'Manusa Door Systems S.L.'
      },
      {
        codigo: 'MG',
        sello: 'selloMG',
        certificado: 'certificado-0001.pfx',
        nombre: 'Manusa Gest S.L.'
      },
      {
        codigo: 'FFX',
        sello: 'selloFFX',
        certificado: 'certificado-0001.pfx',
        nombre: 'Ferroflex S.L.'
      }
    ],
    empresasdemanusa: [
      { codigo: 'RDR', nombre: 'Redor' },
      { codigo: 'MDS', nombre: 'Manusa Door Systems' },
      { codigo: 'MG', nombre: 'Manusa Gest' },
      { codigo: 'FFX', nombre: 'Ferroflex' }
    ],
    empresascomitesdemanusa: [
      { codigo: 'RDR', nombre: 'Redor' },
      { codigo: 'MDSMG', nombre: 'Manusa Door Systems/Manusa Gest' },
      { codigo: 'FFX', nombre: 'Ferroflex' }
    ]
  },
  actions: {},
  mutations: {
    SET_SECCION(state, seccion) {
      state.seccion = seccion;
    }
  },
  modules: {
    user: userStore
  },
  getters: {
    seccion: (state) => state.seccion,
    misCertificadosDeEmpresa: (state) => state.certificadosdeempresa,
    misTipologiasDeBusqueda: (state) => (state.user.tipologias && 'busqueda' in state.user.tipologias ? state.user.tipologias.busqueda : []),
    misTipologiasDeEFirma: (state) => (state.user.tipologias && 'efirma' in state.user.tipologias ? state.user.tipologias.efirma : []),
    miEmail: (state) => state.user.email,
    misDepartamentos: (state) => state.user.departamentos,
    misSecciones: (state) => state.user.secciones,
    misPermisos: (state) => state.user.permisos,
    miModoApp: (state) => state.user.modoapp,
    misEmpresasDeManusa: (state) => state.empresasdemanusa,
    misEmpresasComitesDeManusa: (state) => state.empresascomitesdemanusa,
    tokenusuario: (state) => state.user.token
  }
});
